import { SubtipoTicketEnum, TipoTicketEnum, type CreateMensajeTicketModel, type CreateTicketModel, type AdjuntoMensajeModel } from '@api/api';
import { EntidadTicketEnum } from './EntidadTicketEnum';

export class CreateTicket implements CreateTicketModel {

  IdUsuario: string | null = null;
  Tipo: TipoTicketEnum = TipoTicketEnum.Otros;
  Subtipo: SubtipoTicketEnum | null = null;
  Portal: string = 'Colaboradores';
  Asunto: string = '';
  RefEntidadesAsociadas: string[] = [];
  Mensaje: CreateMensajeTicketModel = {
    Mensaje: '',
    Adjuntos: [] as AdjuntoMensajeModel[],
    Formato: 'text/plain'
  };

  TipoFijado: boolean = false;
  CodigoSecuencialOperacion: string = '';
  
  constructor(data?: Partial<CreateTicket>) {
    Object.assign(this, data);
  }

  static CreateOperacionTicket(guid: string, codigoSecuencial: string, tipoSuministro: string): CreateTicket {
    return new CreateTicket({
      TipoFijado: true,
      Tipo: TipoTicketEnum.Operaciones,
      RefEntidadesAsociadas: [`${EntidadTicketEnum.Operacion}:${guid}?tipo=${tipoSuministro}`],
      CodigoSecuencialOperacion: codigoSecuencial
    });
  }

  static CreateFacturaTicket(idFactura: string): CreateTicket {
    return new CreateTicket({
      TipoFijado: true,
      Tipo: TipoTicketEnum.Facturas,
      Subtipo: null,
      RefEntidadesAsociadas: [`${EntidadTicketEnum.Factura}:${idFactura}`]
    });
  }


}